export default __webpack_public_path__ + "static/media/murderbasementsource.21154b49.jpeg";